import { ReactNode } from 'react';
import { FieldProvenanceType } from '../../schemas/report.schemas';
import './provenanceValueCell.css';

type ProvenanceValueCellPropsType = {
    value: ReactNode;
    provenance?: FieldProvenanceType[];
    // Whether this value may be clicked to inspect its source. When false the value renders as
    // plain, non-interactive text (identical values, missing provenance, restricted users, or
    // source view disabled).
    clickable: boolean;
    onClick?: (provenance: FieldProvenanceType[]) => void;
};

function ProvenanceValueCell({ value, provenance, clickable, onClick }: ProvenanceValueCellPropsType) {
    if (!clickable || !provenance?.length || !onClick) {
        return <>{value}</>;
    }

    return (
        <button
            type="button"
            className="provenance-value-cell"
            onClick={() => onClick(provenance)}
        >
            {value}
        </button>
    );
}

export default ProvenanceValueCell;
